'use client';

import { useState } from 'react';
import { KeyboardArrowDown } from '@mui/icons-material';
import { Box, CircularProgress, Divider, IconButton, Menu, MenuItem, ListItemText, Tooltip } from '@mui/material';
export function MediaDeviceSettings({
  microphones,
  cameras,
  selectedMicId,
  selectedCameraId,
  onMicChange,
  onCameraChange,
  micButton,
  cameraButton,
  isSwitchingMic = false,
  isSwitchingCamera = false,
  isLoading = false,
  groupSx,
  actionButtonSx,
  chevronButtonSx,
  dividerSx,
  menuSx
}) {
  const [micAnchorEl, setMicAnchorEl] = useState(null);
  const [cameraAnchorEl, setCameraAnchorEl] = useState(null);
  const hasMultipleMicrophones = microphones.length > 1;
  const hasMultipleCameras = cameras.length > 1;
  const showMicControl = Boolean(micButton);
  const showCameraControl = Boolean(cameraButton);
  if (!showMicControl && !showCameraControl) {
    return null;
  }
  const handleMicMenuOpen = event => {
    setMicAnchorEl(event.currentTarget);
  };
  const handleCameraMenuOpen = event => {
    setCameraAnchorEl(event.currentTarget);
  };
  const handleMicMenuClose = () => {
    setMicAnchorEl(null);
  };
  const handleCameraMenuClose = () => {
    setCameraAnchorEl(null);
  };
  const handleMicSelect = async deviceId => {
    await onMicChange(deviceId);
    handleMicMenuClose();
  };
  const handleCameraSelect = async deviceId => {
    await onCameraChange(deviceId);
    handleCameraMenuClose();
  };
  const renderControl = ({
    button,
    showChevron,
    isBusy,
    anchorEl,
    onChevronClick,
    onClose,
    selectedId,
    devices,
    onSelect,
    menuLabel
  }) => <Box sx={{
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    overflow: 'hidden',
    ...groupSx
  }}>
            <Tooltip title={button.title}>
                <span>
                    <IconButton onClick={button.onClick} disabled={button.disabled} aria-label={button.title} sx={{
          width: 48,
          height: 48,
          borderRadius: 0,
          ...actionButtonSx
        }}>
                        {button.icon}
                    </IconButton>
                </span>
            </Tooltip>
            {showChevron ? <>
                    <Divider orientation="vertical" flexItem sx={dividerSx} />
                    <Tooltip title={`Switch ${menuLabel}`}>
                        <span>
                            <IconButton onClick={onChevronClick} disabled={isLoading || isBusy} aria-label={`Switch ${menuLabel}`} sx={{
            width: 28,
            height: 48,
            borderRadius: 0,
            ...chevronButtonSx
          }}>
                                {isBusy ? <CircularProgress size={14} /> : <KeyboardArrowDown fontSize="small" />}
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={onClose} anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }} transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }} slotProps={{
        paper: {
          sx: {
            minWidth: 240,
            borderRadius: 2,
            ...menuSx
          }
        }
      }}>
                        {devices.map(device => <MenuItem key={device.deviceId} selected={selectedId === device.deviceId} onClick={() => void onSelect(device.deviceId)}>
                                <ListItemText primary={device.label} />
                            </MenuItem>)}
                    </Menu>
                </> : null}
        </Box>;
  return <>
            {showMicControl ? renderControl({
      button: micButton,
      showChevron: hasMultipleMicrophones,
      isBusy: isSwitchingMic,
      anchorEl: micAnchorEl,
      onChevronClick: handleMicMenuOpen,
      onClose: handleMicMenuClose,
      selectedId: selectedMicId,
      devices: microphones,
      onSelect: handleMicSelect,
      menuLabel: 'microphone'
    }) : null}
            {showCameraControl ? renderControl({
      button: cameraButton,
      showChevron: hasMultipleCameras,
      isBusy: isSwitchingCamera,
      anchorEl: cameraAnchorEl,
      onChevronClick: handleCameraMenuOpen,
      onClose: handleCameraMenuClose,
      selectedId: selectedCameraId,
      devices: cameras,
      onSelect: handleCameraSelect,
      menuLabel: 'camera'
    }) : null}
        </>;
}